// src/components/Testimonials.js
import React from 'react';
import Slider from 'react-slick';


// import img1 from '../images/testimonial/img1.jpg';
// import img2 from '../images/testimonial/img2.jpg';
// import img3 from '../images/testimonial/img3.jpg';
import bg1 from '../images/bg/bg1.jpg';

const Testimonials = () => {
 const testimonials = [
  {
    id: 1,
    text: 'Our weekend at Anand Krushi Paryatan Kendra was absolutely refreshing. The rural activities, traditional food, and peaceful surroundings made it a perfect escape from the city rush. Highly recommend for families!',
    name: 'Mr. Rahul Deshmukh',
    position: 'Software Engineer, Pune',
   
  },
  {
    id: 2,
    text: 'Anand Krushi Paryatan Kendra offered a unique experience with its bullock cart rides, peacock sightings, and open-air games. The hospitality and food reminded me of my village days. Loved every bit of it!',
    name: 'Ms. Sneha Patil',
    position: 'Teacher, Nashik',
   
  },
  {
    id: 3,
    text: 'One of the best picnic spots near Pune! The kids enjoyed the tractor rides and the hurda party was a highlight. Anand Krushi Paryatan Kendra is a hidden gem for a fun, cultural, and relaxing getaway.',
    name: 'Mr. Kunal Joshi',
    position: 'Marketing Executive, Mumbai',
   
  },
];


  // Slick slider settings
  const settings = {
    dots: true, // Show dots for navigation
    infinite: true, // Infinite loop
    speed: 500, // Transition speed in ms
    slidesToShow: 1, // Number of slides to show at a time
    slidesToScroll: 1, // Number of slides to scroll at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 5000, // Time between each slide in ms
    arrows: false, // Hide previous/next arrows
  };

  return (
    <section
      className="testimonial pt-10 pb-20"
      style={{ backgroundImage: `url(${bg1})` }}
    >
      <div className="container">
        <div className="testimonial-in">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <div className="">
                <h4 className="mb-1 theme1">Our Testimonials</h4>
                <h2 className="mb-1 white">
                  Good Reviews By <span className="theme">Clients</span>
                </h2>
                <p className="mb-0 white">
                  Our customers love sharing their experiences with us! Read through their testimonials to see how our products and services have made a positive impact on their lives.
                </p>
              </div>
            </div>
            <div className="col-lg-7">
              <Slider {...settings}>
                {testimonials.map((testimonial) => (
                  <div className="item" key={testimonial.id}>
                    <div className="testimonial-item1">
                      <div className="details d-flex">
                        <i className="fa fa-quote-left fs-1 mb-0"></i>
                        <div className="author-content ms-4">
                          <p className="mb-4 white fs-5 fw-normal">
                            {testimonial.text}
                          </p>
                          <div className="author-info d-flex align-items-center">
                            {/* <img
                              src={testimonial.img}
                              alt={testimonial.name}
                              className="testimonial-img"
                            /> */}
                            <div className="author-title ms-3">
                              <h5 className="m-0 theme1">{testimonial.name}</h5>
                              <span className="white">{testimonial.position}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
      <div className="dot-overlay"></div>
    </section>
  );
};

export default Testimonials;
